import React from "react";
import PosterClasses from "./Poster.module.css";
import Poster1 from "Assets/Homepage/posters/poster_01.png";
import Poster2 from "Assets/Homepage/posters/poster_02.png";
import Poster3 from "Assets/Homepage/posters/poster_03.png";
import Poster4 from "Assets/Homepage/posters/poster_04.png";
function Poster() {
    return (
        <div className={PosterClasses["Container"]}>
            <div className={PosterClasses["poster_1"]}>
                {/* {<img src={Poster1} alt="Poster" />} */}
                <article>
                    <h3>Book Keeping /write-up</h3>
                    <p>
                        small Business Tax return preparation filing
                        instructions is a core service offered to our clients
                    </p>
                </article>
            </div>
            <div className={PosterClasses["wrapper"]}>
                <section>
                    <img src={Poster2} alt="Poster" />
                    <h3>Business & Tax Advisory Service</h3>
                </section>
                <section>
                    <img src={Poster3} alt="Poster" />

                    <h3>Year end Tax planning</h3>
                </section>
                <section>
                    <img src={Poster4} alt="Poster" />
                    <h3>Financial Planning</h3>
                </section>
            </div>
        </div>
    );
}

export default Poster;
